import { Url } from "../avernus/url/source/Url";
import { ILang } from "../languages/Languages";

interface IPaypalConfig{
	merchantName            : string
	merchantPrivacyPolicyURL: string
	merchantUserAgreementURL: string
}

export default class Config{

    public static getLang():ILang{
        return 'en';
    }
    public static getAPIKey():string{
        return 'AIzaSyAScLesC-jD69BAFaSqTVpwrgKergXK35U';
    }

    public static isPaypalSandboxEnabled():boolean{
        return true;
    }

    public static getPaypalClientId(sandboxMode:boolean=false):string{
        return 'AV1EsF3LURLTtoVkSRxoDS6D4RqjWRCW3ArhdIKPtTWpY26a_YynUp925yhAO39jqaWx6GzxJ2_qZCfl';
    }

    public static getFacebookAppId():string{
        return '684160268996100';
    }

    public static getPaypalConfigs():IPaypalConfig{
        return {
            merchantName            : "Sobras test shop",
            merchantPrivacyPolicyURL: "https://sobras.us/privacy-policy/",
            merchantUserAgreementURL: "https://sobras.us/terms-conditions/"
        };
    }

    public static getApiUrl():string{
        return 'https://api.opus-dev.com';
       // return 'https://api.opus.work';
    }

    public static getSimplePayUrl():string{
        return this.getApiUrl()+'/api/simplepay';
    }

    public static isTestVersion():boolean{
        return Config.getApiUrl().indexOf('.work') > -1;
    }

    public static isTestVersionAndBrowser():boolean{
        return (Config.getApiUrl().indexOf('.work') > -1 && Url.isBrowser() === true);
    }
}
